import { render } from "./ClientsSection.vue?vue&type=template&id=13810c77"
const script = {}

import "./ClientsSection.vue?vue&type=style&index=0&id=13810c77&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__